import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useLoading } from "../contexts/LoadingContext";
import Loader from "../components/loader";

const ConversionLogin = () => {
  const { setIsLoading } = useLoading();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Get name and msisdn from URL parameters
  const name = searchParams.get("name") || "";
  const msisdn = searchParams.get("msisdn") || "";

  // useEffect(() => {
  //   if (typeof window.gtag !== 'undefined') {
  //     window.gtag('event', 'conversion', {
  //       send_to: 'AW-17300193684/IK1rCJaE36EbEJSDsLlA',
  //       value: 1.0,
  //       currency: 'PKR',
  //       transaction_id: ''
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17300193684/jGcFCI-rwqkbEJSDsLlA',
        transaction_id: ''
      });
    }
  }, []);

  useEffect(() => {
    const handleLogin = async () => {
      // Check if required parameters are present
      if (!name || !msisdn) {
        console.error("Missing required parameters: name or msisdn");
        window.location.href = "http://digital.webdocoffice.com.pk/";
        return;
      }

      setIsLoading(true);

      try {
        const response = await authenticateUser(msisdn, name);
        if (response.data.patientProfile.isFeaturePackageActivated) {
          navigate("/dashboard");
        } else {
          navigate("/feature-package");
        }
      } catch (error) {
        console.error("Error during authentication:", error);
        window.location.href = "http://digital.webdocoffice.com.pk/";
      } finally {
        setIsLoading(false);
      }
    };

    handleLogin();
  }, [name, msisdn, navigate, setIsLoading]);
  const authenticateUser = async (userMsisdn, userPName) => {
    try {
      const response = await axios.post(
        "https://bundleapi.webddocsystems.com/api/Account/Register",
        {
          mobileNumber: userMsisdn,
          customerName: userPName,
          gender: "male",
        }
      );

      const user = {
        userMsisdn: response.data.patientProfile.mobileNumber,
        userName: response.data.patientProfile.name,
        applicationUserId: response.data.patientProfile.id,
        userEmail: `${response.data.patientProfile.mobileNumber}@webdoc.com.pk`,
        package: response.data.patientProfile.isPackageActivated,
        featuresPackage: response.data.patientProfile.isFeaturePackageActivated,
        headOfGreeting: response.data.patientProfile.headOfGreeting,
        contentOfGreeting: response.data.patientProfile.contentOfGreeting,
        appointmentId: response.data.patientProfile.appointmentid,
        featurePackageDetails:
          response.data.patientProfile.featurePackageDetails,
        message: "User registered and authenticated successfully.",
      };
      sessionStorage.setItem("userData", JSON.stringify(user));
      return response;
    } catch (error) {
      console.error("Error registering user:", error);
      throw error;
    }
  }; return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      flexDirection: 'column'
    }}>
      <Loader />
      <p style={{ textAlign: 'center', fontSize: '18px', marginTop: '20px' }}>Processing login...</p>
    </div>
  );
};

export default ConversionLogin;
